var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106px",
        height: "106px",
        viewBox: "0 0 106 106",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "pill-lt",
            points:
              "0.000211111111 0.763166667 56.2347222 0.763166667 56.2347222 57 0.000211111111 57"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-485.000000, -413.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(485.000000, 413.000000)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M106,90.9548646 C106,99.2637914 99.2146745,106 90.8451633,106 L15.1548367,106 C6.78532554,106 0,99.2637914 0,90.9548646 L0,15.0451354 C0,6.73520562 6.78532554,0 15.1548367,0 L90.8451633,0 C99.2146745,0 106,6.73520562 106,15.0451354 L106,90.9548646 Z",
                      id: "Mask",
                      fill: "#831D64"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-6",
                        transform: "translate(25.000000, 25.000000)"
                      }
                    },
                    [
                      _c("g", { attrs: { id: "Group-3" } }, [
                        _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                          _c("use", { attrs: { "xlink:href": "#pill-lt" } })
                        ]),
                        _vm._v(" "),
                        _c("g", { attrs: { id: "Clip-2" } }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M45.5548222,30.8760556 L45.3373778,32.0572222 C44.0274333,39.1843333 38.3823222,44.8305 31.2900444,46.1066667 L30.1458222,46.3156667 L26.1241556,46.3167222 L24.9451,46.1003333 C17.8179889,44.7893333 12.1718222,39.1431667 10.8946,32.0519444 L10.6877111,30.9087778 L10.6813778,26.8892222 L10.8998778,25.7080556 C12.2182667,18.5798889 17.8654889,12.9337222 24.9493222,11.6586111 L26.1083222,11.4485556 L30.1141556,11.4485556 L31.2953222,11.6649444 C38.4224333,12.9748889 44.0686,18.6189444 45.3458222,25.7091111 L45.5537667,26.8554444 L45.5548222,30.8760556 Z M54.0309333,26.676 L49.9195444,26.676 L49.8245444,25.9613889 C48.5494333,16.1806111 40.8248778,8.45711111 31.0398778,7.17672222 L30.3252667,7.08488889 L30.3252667,2.96927778 C30.3252667,1.75222222 29.3351556,0.763166667 28.1159889,0.763166667 C26.9010444,0.763166667 25.9130444,1.75222222 25.9130444,2.96927778 L25.9130444,7.08488889 L25.1994889,7.17672222 C15.4187111,8.45077778 7.69521111,16.1753333 6.41376667,25.9624444 L6.32087778,26.676 L2.20737778,26.676 C0.969211111,26.676 0.000211111111,27.6439444 0.000211111111,28.88 C0.000211111111,30.0981111 0.989266667,31.0882222 2.20737778,31.0882222 L6.32087778,31.0882222 L6.41376667,31.8038889 C7.68993333,41.5815 15.4144889,49.305 25.1994889,50.5885556 L25.9130444,50.6825 L25.9130444,54.7949444 C25.9130444,56.0109444 26.9010444,57 28.1159889,57 C29.3351556,57 30.3252667,56.0109444 30.3252667,54.7949444 L30.3252667,50.6803889 L31.0398778,50.5885556 C40.8196,49.3134444 48.5431,41.5878333 49.8245444,31.8007222 L49.9184889,31.0882222 L54.0309333,31.0882222 C55.2469333,31.0882222 56.2349333,30.0981111 56.2349333,28.88 C56.2349333,27.6650556 55.2469333,26.676 54.0309333,26.676 L54.0309333,26.676 Z",
                            id: "Fill-1",
                            fill: "#FDFDFD",
                            mask: "url(#mask-2)"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M36.0929603,32.1259212 L30.4162052,28.0981255 L30.4162052,17.1426876 C30.4162052,15.9617686 29.4263845,15 28.2086376,15 C26.9908907,15 26,15.9617686 26,17.1426876 L26,29.1866067 C26,29.8689846 26.3381441,30.5160493 26.9031445,30.9159207 L33.4873244,35.5866264 C33.8736219,35.8577081 34.323054,36 34.7885372,36 C35.4915774,36 36.1593051,35.6707552 36.5755648,35.1202829 C36.9233396,34.6580939 37.0645897,34.0920421 36.9725631,33.5249518 C36.8816066,32.9589 36.5691443,32.4624363 36.0929603,32.1259212",
                          id: "Fill-4",
                          fill: "#FDFDFD"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }